import { useCallback } from 'react'
import { NavigateOptions, useNavigate, useParams } from 'react-router-dom'
import { ActivityPartAxis } from '@/api/models/aggregate'
import { useActivitiesWithAggregates } from '@/hooks/useActivityParts/useActivitiesWithAggregates'

export const getCompositionUrlWithAxis = ({
  objectiveId,
  activityPartAxis,
}: {
  objectiveId: string
  activityPartAxis: ActivityPartAxis
}) => `/courses/${objectiveId}/view/content/${activityPartAxis}${document.location.search}`

export const useNavigateToActivityPartByAxis = () => {
  const { objectiveId } = useParams()
  const navigate = useNavigate()
  const activitiesWithAggregates = useActivitiesWithAggregates()

  const navigateToActivityPartByAxisForce = useCallback(
    (activityPartAxis: ActivityPartAxis, options?: NavigateOptions) => {
      navigate(getCompositionUrlWithAxis({ objectiveId: objectiveId!, activityPartAxis }), options)
    },
    // navigate cause unnecessary re-rendering
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [objectiveId],
  )

  const navigateToActivityPartByAxis = useCallback(
    (activityPartAxis: ActivityPartAxis, options?: NavigateOptions) => {
      if (!activitiesWithAggregates) {
        return
      }

      navigateToActivityPartByAxisForce(activityPartAxis, options)
    },
    [activitiesWithAggregates, navigateToActivityPartByAxisForce],
  )

  return {
    navigateToActivityPartByAxis,
    navigateToActivityPartByAxisForce,
  }
}
